// @flow
import React from 'react';
import { pure } from 'recompose';
import { Carousel, CarouselItem } from 'angieslist-react-components';
import CouponCarouselItem from './CouponCarouselItem';
import type { Coupon } from '../../types';
import './couponCarousel.scss';

type Props = {
  coupons: Coupon[],
};

type State = {
  direction: ?string,
  index: number,
}

class CouponCarouselComponent extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      direction: null,
      index: 0,
    };
  }

  state: State;
  props: Props;

  render() {
    const { coupons } = this.props;
    const { direction, index } = this.state;
    return (
      <Carousel
        className="coupon-carousel"
        controls={coupons.length > 1}
        activeIndex={index}
        direction={direction}
        onSelect={(selectedIndex, selectedDirection) => {
          // tracker code to go here
          this.setState(() => ({
            index: selectedIndex,
            direction: selectedDirection,
          }));
        }}
        wrap
      >
        {coupons.map(coupon => (
          <CarouselItem key={coupon.couponId}>
            <CouponCarouselItem {...coupon} />
          </CarouselItem>))}
      </Carousel>
    );
  }
}

export default (pure(CouponCarouselComponent): any);



// WEBPACK FOOTER //
// ./src/modules/store/browser/components/CouponCarousel.js